import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import {CardTitle} from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { PredictiveModelTooltip } from '../tooltips/PredictiveModelTooltip';
import { PredictiveModelThumbnail } from './PredictiveModelThumbnail';

export class PredictiveModelCard extends ContentCard {
  public render() {
    const { content, hovered, selected, urls, addContentFavorite, removeContentFavorite } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        <PredictiveModelThumbnail
          hovered={hovered}
          selected={selected}
          navigateUrl={getContentUrlForItem(content, urls)}
          owner={content.owner}
          urls={urls}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          <CardTitle name={content.name} />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.predictiveModelTooltipTitle()}
            />
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'predictiveModel'})}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'predictiveModel'})} />
          </span>
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return PredictiveModelTooltip;
  }
}
